import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "distance-and-shipping-filter",
  "data-component-name": "distance-and-shipping-filter"
}
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "distance-shipping-title px-6 py-4" }
const _hoisted_5 = {
  key: 0,
  class: "divShipToStoreContainer px-6 py-4 d-flex"
}
const _hoisted_6 = { class: "d-flex flex-column align-center px-6 py-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "your-location" }, "Your location:", -1)
const _hoisted_8 = { class: "shopByStoreToggle" }
const _hoisted_9 = {
  key: 1,
  class: "zipLocation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterMenuLineItem = _resolveComponent("FilterMenuLineItem")!
  const _component_ShipToStoreToggle = _resolveComponent("ShipToStoreToggle")!
  const _component_sc_image = _resolveComponent("sc-image")!
  const _component_ShopByStoreToggle = _resolveComponent("ShopByStoreToggle")!
  const _component_ZipLocation = _resolveComponent("ZipLocation")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_FilterMenuLineItem, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandFilter())),
            isSelected: true,
            title: _ctx.pageTitle,
            "data-role": "facet-filter"
          }, null, 8, ["title"])
        ], 512), [
          [_vShow, !_ctx.distanceShippingFilterSelected && !_ctx.filterSelected]
        ]),
        (_ctx.distanceShippingFilterSelected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!_ctx.filterZipFlyout)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.pageTitle), 1),
                    (_ctx.shipToStoreToggleFeatureFlag)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_ShipToStoreToggle)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          class: "clickable-zip",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFilterZipFlyout(true))),
                          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.setFilterZipFlyout(true)), ["enter"])),
                          tabindex: "0",
                          "data-action-toggle-filter": "zip-code"
                        }, [
                          _createVNode(_component_sc_image, {
                            class: "icon-location-header-flyout",
                            media: _ctx.fields.iconLocationFlyout,
                            height: "24",
                            width: "24"
                          }, null, 8, ["media"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.zipCode), 1)
                        ], 32)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_ShopByStoreToggle, { fields: _ctx.fields }, null, 8, ["fields"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_Transition, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ZipLocation, { fields: _ctx.fields }, null, 8, ["fields"])
                      ]),
                      _: 1
                    })
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}